export const FileTypes = {
    ZIP:'application/zip',
    PDF: 'application/pdf',
    CSV: 'text/csv',
    OPEN_XL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    MS_XL: 'application/vnd.ms-excel',
    NONE: '',
};

export const FileFormat = {
    PDF: 'PDF',
    CSV: 'CSV',
    XLSX: '.XLSX',
    XLS: '.XLS',
};
